import React, { PureComponent } from 'react';
import { Container, Row, Col, FormGroup, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert, Input } from 'reactstrap';
import Datetime from "react-datetime";
import CurrencyInput from 'components/CurrencyInput/CurrencyInput';

export default class MarkAsPaidModal extends PureComponent {
	constructor(props) {
		super(props)
		this.state = {
			modal: false,
			settled_date: null,
			sales_invoice: null,
			acknowledgement_receipt: null,
			note: '',
			isPartialPayment: false,
			payment: 0,
			error: ''
		}
		this.invoiceInput = React.createRef()
		this.receiptInput = React.createRef()
	}

	toggle = () => this.setState(prevState => ({ modal: !prevState.modal, settled_date: null, isPartialPayment: false, error: '', note: '', sales_invoice: null, acknowledgement_receipt: null }));

	onChangeSettledDate = (settled_date) => {
		this.setState({
			settled_date
		});
	}

	onChangeFiles = (e) => {
		console.log(e)
	}

	componentDidUpdate(prevProps) {
		if(this.props.error !== prevProps.error) {
			this.setState({
				error: this.props.error
			});
		}
	}

	onSave = () => {
		const { 
			settled_date,
			sales_invoice,
			acknowledgement_receipt,
			note,
			isPartialPayment,
			payment
		} = this.state;
		const { 
			onSave
		} = this.props;
		const totalNumberOfPayments = this.getTotalPayments();

		onSave(settled_date.toDate(), sales_invoice, acknowledgement_receipt, note, isPartialPayment && totalNumberOfPayments === 1, payment)
	}

	getTotalPayments = () => {
		const {
			selectedPayments
		} = this.props;
		return Object.keys(selectedPayments).filter(paymentId => !!selectedPayments[paymentId]).length;
	}

	render() {

		const { 
			settled_date,
			sales_invoice,
			acknowledgement_receipt,
			note,
			isPartialPayment,
			payment,
			error
		} = this.state;

		const {
			loading
		} = this.props;

		const totalNumberOfPayments = this.getTotalPayments();

		return (
			<Modal isOpen={this.state.modal} toggle={this.toggle}>
				<ModalHeader>Mark as Paid</ModalHeader>
				<ModalBody>
					<Container>
						<Row>
							<Col>
								<FormGroup>
									<Label>Settled Date <span className="required-start">*</span></Label>
									<Datetime
										inputProps={{
											className: "form-control",
											placeholder: "Settled Date",
											name: "reservation_date"
										}}
										dateFormat="MM/DD/YYYY"
										timeFormat={false}
										value={settled_date}
										onChange={this.onChangeSettledDate}
										closeOnSelect={true}
									/>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col>	
								<FormGroup>
									<Label>Note</Label>
									<Input placeholder="Note" value={note} type="text" onChange={(event) => this.setState({ note: event.target.value })}></Input>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col>	
								<FormGroup>
									<div className="form-check">
										<label className="form-check-label">
												<input type="checkbox" className="form-check-input" onChange={(e) => this.setState({ isPartialPayment: e.target.checked })} />
													Is partial payment
												<span className="form-check-sign">
													<span className="check"></span>
												</span>
										</label>
									</div>
									{
										isPartialPayment && totalNumberOfPayments > 1 ? <Alert color="warning">You can only mark one payment as partial payment at a time</Alert> : null
									}
								</FormGroup>
							</Col>
						</Row>
						{isPartialPayment && totalNumberOfPayments === 1 ? <Row>
							<Col>
								<FormGroup>
									<CurrencyInput
										name="price"
										placeholder="Price"
										price={payment}
										onChange={(value) => this.setState({ payment: value })}
									/>
								</FormGroup>
							</Col>
						</Row> : null}
						<Row>
                            <Col>
                                <FormGroup>
                                    <Label className='d-block'>Sales Invoice <span className="required-start">*</span></Label>
                                    <input
                                        type="file"
                                        name="sales_invoice"
                                        onChange={(e) => this.setState({ sales_invoice: e.target.files[0] })}
                                        style={{display: 'none'}}
										ref={this.invoiceInput}
                                    />
                                    <Button
                                            className="btn-round"
                                            color="info"
                                            onClick={() => this.invoiceInput.current.click()}
                                            style={{fontSize: '14px'}}
                                        >	
                                            Upload{" "}
                                            <i className="tim-icons icon-upload" />
                                        </Button>
                                    <span>{sales_invoice?.name}</span>
                                </FormGroup>
                            </Col>
                        </Row>
						<Row>
                            <Col>
                                <FormGroup>
                                    <Label className='d-block'>Acknowledgement Receipt <span className="required-start">*</span></Label>
                                    <input
                                        type="file"
                                        name="acknowledgement_receipt"
                                        onChange={(e) => this.setState({ acknowledgement_receipt: e.target.files[0] })}
                                        style={{display: 'none'}}
										ref={this.receiptInput}
                                    />
                                    <Button
                                            className="btn-round"
                                            color="info"
                                            onClick={() => this.receiptInput.current.click()}
                                            style={{fontSize: '14px'}}
                                        >	
                                            Upload{" "}
                                            <i className="tim-icons icon-upload" />
                                        </Button>
                                    <span>{acknowledgement_receipt?.name}</span>
                                </FormGroup>
                            </Col>
                        </Row>
					</Container>
					{error && 
                        <Alert color="danger">
                            {error}
                        </Alert>
                    }
				</ModalBody>
				<ModalFooter className="justify-content-end">
						<Button 
							color="primary" 
							className="btn-success-override mr-2"
							style={{}} 
							disabled={!!(!settled_date || !(sales_invoice || acknowledgement_receipt)) || loading}
							onClick={this.onSave}
						>
							{loading ? "Saving" : "Save"}
						</Button>
						<Button color="secondary" className="btn-danger-override" onClick={this.toggle}>Cancel</Button>
				</ModalFooter>
			</Modal>
		)
	}
}